import React, { useState, useEffect } from "react";
import "./comparison.css";
import Meta from "utils/meta";
import RealtyRedefinedFeatures from "utils/ComparionData/realtyRedefinedFeatures";
import RealtyRedefinedDetailedFeatures from "utils/ComparionData/realtyRedefinedDetailedFeatures";
import SubPageHeader from "Component/SubPageHeader/subPageHeader";
import ComparisonTopTabs from "Component/ComparisonTopTabs/ComparisonTopTabs";
import ComparisonSideMenu from "Component/ComparisonSideMenu/ComparisonSideMenu";
import ComparisonFeatures from "Component/ComparisonFeatures/ComparisonFeatures";
import ComparisonSalientFeatures from "Component/ComparisonSalientFeatures/ComparisonSalientFeatures";
import DetailedComparisonTable from "Component/ComparisonFeatures/DetailedComparisonTable";

const RealtyRedefined = () => {
  const sideMenu = [
    {name: "Best Real Estate CRM", link: "top-intro-section"},
    {name: "Features: Realtor vs Realty Redefined", link: "comparison-features-section"},
    {name: "Salient Features", link: "comparison-salient-features"},
    {name: "Detailed Comparison", link: "detailed-comparison"}
  ];
  const [activeDetailedComparison, setActiveDetailedComparison] = useState([]);

  const handleDetailedComparisonTab = (index) => {
    if (activeDetailedComparison.includes(index)) {
      setActiveDetailedComparison(activeDetailedComparison.filter(item => item !== index));
    } else {
      setActiveDetailedComparison([...activeDetailedComparison, index]);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<>
      <Meta title="Realty Redefined | The Realtor Desk" description="" />
      <div className="sub-page--outer">
        <SubPageHeader
            title="Realtor Real Estate CRM: The Choice of India’s Top Real Estate Developers"
            subTitle="What makes Realtor a better alternative to RealtyRedefined is its extensive list of real estate-specific features, services and low cost of ownership."
        />
        <ComparisonTopTabs
            activeTab={2}
        />
        <div className="container comparison-outer">
          <div className="comp-side--menu">
            <h4>Comparison Tools</h4>
            <ComparisonSideMenu
                sideMenu={sideMenu}
                currentActive={sideMenu[0].link}
            />
          </div>
          <div className="comp-side--content">
            <div className="top-title-section" id="top-intro-section">
              <h4>The Choice of India’s Top Real Estate Developers</h4>
              <p>What makes Realtor Real Estate a better alternative to RealtyRedefined is its extensive list of real estate-specific features, services and low cost of ownership. Realtor Real Estate has enterprise features like workflow management, marketing automation features, calling & communication platform and Dual Data Security which cater to the specific needs of Real Estate Developers. Realtor Real Estate also has a mobile app that enables on-the-go functionality…all at zero additional cost.</p>
            </div>
            <ComparisonFeatures
                features={RealtyRedefinedFeatures}
                title="Better Real Estate with Realtor Features"
                platform="Realty Redefined"
            />
            <ComparisonSalientFeatures
                title="Salient Feature of Realtor Real Estate : An Alternative to Realty Redefined CRM for Real Estate"
            />
            <div className="detailed-comparison-section--outer" id="detailed-comparison">
              <h4>How Realtor Real Estate is a Better Alternative to Realty Redefined</h4>
              <div className="comparison-table--accordion">
                {RealtyRedefinedDetailedFeatures.map((singleFeature, index) => (
                    <div key={index} className="comparison--accordion-item">
                      <div className={`comparison--accordion-title ${activeDetailedComparison.includes(index) ? "active-title" : ""}`} onClick={() => handleDetailedComparisonTab(index)}>
                        <span>{singleFeature.tab_heading}</span>
                        {activeDetailedComparison.includes(index) ? (<i className="fa fa-minus" />) : (<i className="fa fa-plus" />)}
                      </div>
                      {activeDetailedComparison.includes(index) && (
                          <DetailedComparisonTable
                              features={singleFeature.tab_info}
                              platform="Realty Redefined"
                          />
                      )}
                    </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RealtyRedefined;
